<ng-container
  *ngIf="{gallery: templatesFacade.quorumGallery$ | async, library: templatesFacade.quorumLibrary$ | async,
  selectedLanguage: templatesFacade.selectedLanguage$ | async, supportedLanguages: templatesFacade.quorumLibrarySupportedLanguages$ | async } as quorumTemplates">
  <div>
    <h1 class="text-2xl font-semibold text-grey-900 mb-6">Gallery</h1>
  </div>
  <div class="w-full flex flex-row flex-wrap place-content-between items-center">
    <div *ngFor="let template of quorumTemplates.gallery | orderBy: ['name']">
      <a [routerLink]="'gallery/editor/' + template.id" [queryParams]="{language: selectedLanguage}">
        <div class="flex flex-col rounded-lg overflow-hidden w-full max-w-xs bg-white mb-8 ml-4 mr-4 shadow-2xl grow">
          <img class="h-auto w-full" [src]="template.languageDefinitionMap['en'].previewImageUrl">
          <mat-divider></mat-divider>
          <div class="flex flex-col p-4">
            <div class="flex flex-row place-content-around items-center mb-1.5">
              <h3 class="flex-grow font-bold m-0 text-black"
                style="text-decoration:underline; text-decoration-style: double;text-decoration-color: rgb(1,90,156);">
                {{template.languageDefinitionMap['en'].name}}</h3>
            </div>
            <span class="text-grey-600">{{template.languageDefinitionMap['en'].description}}</span>
          </div>
        </div>
      </a>
    </div>
  </div>

  <div class="flex flex-row place-content-between my-6 items-center">
    <div>
      <h1 class="text-2xl font-semibold text-grey-900 ">Library - {{quorumTemplates.selectedLanguage === 'en' ?
        'English' : 'French'}}</h1>
    </div>
    <ng-container>
      <div *ngIf="quorumTemplates.supportedLanguages?.length > 1" class="flex flex-row">
        <mat-button-toggle-group [(ngModel)]="quorumTemplates.selectedLanguage" (change)="setLanguage($event.value)"
          name="selectedLanguage" aria-label="Select Language">
          <mat-button-toggle *ngFor="let language of quorumTemplates.supportedLanguages"
            [value]="language">{{language.toUpperCase()}}
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </ng-container>
  </div>

  <div class="w-full flex flex-row flex-wrap place-content-between items-center">
    <div *ngFor="let template of quorumTemplates.library | orderBy: ['name']">
      <a [routerLink]="'library/editor/' + template.id" [queryParams]="{language: quorumTemplates.selectedLanguage}">
        <div class="flex flex-col rounded-lg overflow-hidden w-80 ml-4 mr-4 bg-white mb-8 shadow-2xl grow">
          <img class="h-auto w-full"
            [src]="template.languageDefinitionMap[quorumTemplates.selectedLanguage].previewImageUrl">
          <mat-divider></mat-divider>
          <div class="flex flex-col p-4">
            <div class="flex flex-row place-content-between items-center mb-1.5">
              <h3 class="flex-grow font-bold m-0 text-black"
                style="text-decoration:underline; text-decoration-style: double;text-decoration-color: rgb(1,90,156);">
                {{template.languageDefinitionMap[quorumTemplates.selectedLanguage].name}}</h3>
            </div>
            <span
              class="text-grey-600">{{template.languageDefinitionMap[quorumTemplates.selectedLanguage].description}}</span>
          </div>
        </div>
      </a>
    </div>
  </div>
</ng-container>